export default {
  page: 'Page',
};
